import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SecurityHeaders } from "@/components/SecurityHeaders";
import { LandingPageOptimizer } from "@/components/LandingPageOptimizer";
import { PerformanceOptimizer } from "@/components/PerformanceOptimizer";
import { AdminAuthProvider } from "@/components/AdminAuth";
import { AnalyticsProvider } from "@/components/AnalyticsProvider";
import { GoogleAnalytics } from "@/components/GoogleAnalytics";
import Index from "./pages/Index";
import { Chateaux } from "./pages/Chateaux";
import { ChateauDetail } from "./pages/ChateauDetail";
import Sumos from "./pages/Sumos";
import { Blog } from "./pages/Blog";
import { BlogPost } from "./pages/BlogPost";
import FAQ from "./pages/FAQ";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import ResetPassword from "./pages/ResetPassword";
import AdminLogin from "./pages/AdminLogin";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <SecurityHeaders />
    <TooltipProvider>
        <AdminAuthProvider>
          <AnalyticsProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <GoogleAnalytics />
              <LandingPageOptimizer />
              <PerformanceOptimizer />
              <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/chateaux" element={<Chateaux />} />
              <Route path="/chateau/:id" element={<ChateauDetail />} />
              <Route path="/sumos" element={<Sumos />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/admin" element={<AdminLogin />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </AnalyticsProvider>
        </AdminAuthProvider>
      </TooltipProvider>
  </QueryClientProvider>
);

export default App;
